export class FontProperty {
  fontSize: string;
  fontFamily: string;
  textDecoration: string;
  color: string | 'rgba(0,0,0,1)';
  content: string;
  height: string;
  width: string;
  indexColumn?: number;
  indexRow?: number;
  indexCell?: number;
  indexElement?: number;
  elementType?: string;
  backgroundColor: string;
  borderRadius: string;
  fontWeight: string;
  textAlign: string;
}
